import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getMonthlyLeadsReport } from "../../services/montlyleads.services";

// Async thunk for fetching monthly leads report
export const fetchMonthlyLeadsReport = createAsyncThunk(
  "monthlyLeads/fetchReport",
  async ({ month, year }, { rejectWithValue }) => {
    try {
      const data = await getMonthlyLeadsReport(month, year);
      return {
        data: data.data, // Weekly data
        list: data.list, // Leads data
      };

      // return data.data; // Return the "data" field for the chart
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const monthlyLeadsSlice = createSlice({
  name: "monthlyLeads",
  initialState: {
    data: [], // Holds the date-wise leads data
    list: [], // Holds the leads list data
    status: "idle", // idle | loading | succeeded | failed
    error: null, // Holds any error message
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchMonthlyLeadsReport.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchMonthlyLeadsReport.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload; // Update state with the API response
        state.list = action.payload.list; // Store leads list data
      })
      .addCase(fetchMonthlyLeadsReport.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export default monthlyLeadsSlice.reducer;
